import React from "react";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";

const GoogleAuth = ({ onLoginSuccess }: { onLoginSuccess: (token: string) => void }) => {
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log("Google Auth Success:", tokenResponse);
      onLoginSuccess(tokenResponse.access_token);
    },
    onError: (error) => {
      console.error("Google Auth Error:", error);
    },
    scope: "https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/drive.file", // Google Calendar & Drive access
  });

  return (
    <>
      <button onClick={() => login()} className="btn btn-primary me-3">
        Login with Google
      </button>
    </>
  );
};

export default GoogleAuth;
